import { useEditor } from '@smartfire/js-block-engine';
import { Skeleton } from '@mui/material';
import { __ } from '../../../shared/tools';
import { useStoreAddToCart } from '../../../shared/hooks/useStoreAddToCart';
import { Button } from '../../../button/block';
import clsx from 'clsx';
import he from 'he';
import style from './style.module.scss';

export const ProductTile = ({ product, showTags = true, buttons = {}, ...props }) => {
    const { isEditing } = useEditor();
    const { images, is_purchasable, name, nb_variations, permalink, price_html, subtitle, type } = product;
    const { addToCart, addingToCart } = useStoreAddToCart(product.id);
    const image = images && images.length > 0 ? images.find((element) => element.type === 'face') ?? images[0] : null;
    const image_hover =
        images && images.length > 1 ? images.find((element) => element.type === 'detail') ?? images[1] : null;

    const handleAddToCart = async (e) => {
        e.preventDefault();
        await addToCart(1).then(() => {
            window.location.reload(); // Recharge la page pour afficher le cart actualisé
        });
    };

    return (
        <li className={clsx(style.item, props.className)}>
            <a href={isEditing ? () => false : permalink} className={clsx('wc-block-grid__product-link', style.link)}>
                {showTags && <ProductTags product={product} />}
                {image && <img src={image.src} alt={name} className={style.thumbnail} />}
                {image_hover && (
                    <img src={image_hover.src} alt={name} className={clsx(style.thumbnail, style.detail)} />
                )}
                <div className={clsx(style.row, style.wrap)}>
                    <p className={style.title}>{he.decode(name)}</p>
                    {nb_variations > 1 && (
                        <p className={style.nb_variations}>{__('{{nb}} autres coloris', { nb: nb_variations })}</p>
                    )}
                </div>
                {subtitle && <p className={clsx(style.row, style.subtitle)}>{subtitle}</p>}
                {price_html && (
                    <p className={clsx(style.row, style.price)} dangerouslySetInnerHTML={{ __html: price_html }} />
                )}
                {buttons.discover && (
                    <Button type="filled" className={style.button} tagName="p">
                        {__('Découvrir')}
                    </Button>
                )}
                {buttons.addToCart && is_purchasable && type !== 'variable' && (
                    <Button
                        onClick={handleAddToCart}
                        type="outlined"
                        className={style.button}
                        tagName="button"
                        disabled={addingToCart}
                    >
                        {__('Ajouter au panier')}
                    </Button>
                )}
            </a>
        </li>
    );
};

const ProductTags = ({ product }) => {
    const { is_new, prices, web_exclusivity, shop_exclusivity } = product;
    return (
        <ul className={style.badges}>
            {is_new && <li className={style.badge}>{__('Nouveauté')}</li>}
            {web_exclusivity && <li className={style.badge}>{__('Exclusivité web')}</li>}
            {shop_exclusivity && <li className={style.badge}>{__('Exclusivité boutique')}</li>}
            {prices.sale_percentage > 0 && <li className={style.badge}>{'-' + prices.sale_percentage + '%'}</li>}
        </ul>
    );
};

export const LoadingTile = ({ ...props }) => {
    return (
        <li className={clsx(style.item, style.loading, props.className)}>
            <div className={clsx('wc-block-grid__product-link', style.link)}>
                <Skeleton variant="rectangular" className={clsx(style.thumbnail, style.skeleton)} />
                <div className={style.row}>
                    <Skeleton variant="text" width={60} />
                    <Skeleton variant="text" width={60} />
                </div>
                <div className={style.row}>
                    <Skeleton variant="text" width={120} />
                </div>
                <div className={style.row}>
                    <Skeleton variant="text" width={50} />
                </div>
            </div>
        </li>
    );
};
